import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PetMood } from "@miezmission/shared-types";
import { ProgressBar } from "./ProgressBar";
const moodEmoji = {
    [PetMood.Ecstatic]: "🤩",
    [PetMood.Happy]: "😸",
    [PetMood.Content]: "😺",
    [PetMood.Neutral]: "😐",
    [PetMood.Sad]: "😿",
    [PetMood.Unhappy]: "😾",
    [PetMood.Distressed]: "🙀",
};
export function PetCard({ pet }) {
    const emoji = moodEmoji[pet.mood];
    return (_jsxs("div", { className: "bg-white rounded-2xl shadow-md p-6 flex flex-col items-center gap-4", children: [_jsx("div", { className: "text-7xl", children: emoji }), _jsx("h2", { className: "text-2xl font-bold text-gray-800", children: pet.name }), _jsxs("div", { className: "w-full space-y-3", children: [_jsx(ProgressBar, { value: pet.happiness, max: 100, label: "Gl\u00FCck", colorClass: "bg-pink-400", showValue: true }), _jsx(ProgressBar, { value: pet.experiencePoints % 500, max: 500, label: `Level ${pet.level}`, colorClass: "bg-purple-500", showValue: false })] }), pet.streakDays > 0 && (_jsxs("div", { className: "flex items-center gap-2 text-orange-500 font-semibold", children: [_jsx("span", { children: "\uD83D\uDD25" }), _jsxs("span", { children: [pet.streakDays, " Tage Streak!"] })] }))] }));
}
//# sourceMappingURL=PetCard.js.map